import { createSlice } from '@reduxjs/toolkit';
import { createAction } from '@reduxjs/toolkit';

export const startEmbeddedSignup = createAction('START_EMBEDDED_SIGNUP');

const initialState = {
  loading: false,
  error: null,
  success: false,
  lastPayload: null
};

const whatsappSignupSlice = createSlice({
  name: 'whatsappSignup',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload; },
    setError: (state, action) => { state.error = action.payload; },
    setSuccess: (state, action) => { state.success = action.payload; },
    setLastPayload: (state, action) => { state.lastPayload = action.payload; },
    clearState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.lastPayload = null;
    }
  }
});

export const { setLoading, setError, setSuccess, setLastPayload, clearState } = whatsappSignupSlice.actions;

export default whatsappSignupSlice.reducer;
